import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Apt } from "./interface";

const initialState: Apt = {
  info: [],
};

/***********************************
 * exported to PropertiesUpdate.tsx
 * error cannot be named without a reference to '@reduxjs/toolkit/node_modules/immer
 * make sure that is being exported once only
 ***********************************/

const aptSlice = createSlice({
  name: "apt",
  initialState,

  reducers: {
    onCurrentAptInfo: (state, action: PayloadAction<any[]>) => {
      state.info = action.payload;
    },

    // // use in the invoice component - retrieve the data for automatic count
    // addInvoiceId: (state, action: PayloadAction<any[]>) => {
    //   state.invoiceId = action.payload;
    // }
  },
});
export const { onCurrentAptInfo } = aptSlice.actions;
export default aptSlice.reducer;
